/**
 * Funzione di hash per determinare il segmento dell utente
 *
 * @author Giovanni Citro
 * @param initial stringa utente
 * @returns Valore percentuale randon
 */
function getUserSegment(userId) {
    let hash = 0;
    for (let i = 0; i < userId.length; i++) {
        hash = (hash << 5) - hash + userId.charCodeAt(i);
        hash |= 0;
    }
    return Math.abs(hash % 100);
}
export function getTestCase(userId, testConf, window) {
    const { cases, defaultCase, stickiness, stickinessTime } = testConf;
    if (stickiness) {
        let storedSegment = getStoredSegment(userId);
        if (storedSegment && isSegmentValid(storedSegment.timestamp, stickinessTime)) {
            if (!window['lazy_test_case'])
                window['lazy_test_case'] = storedSegment.config;
            return storedSegment.config;
        }
    }
    const segment = getUserSegment(userId);
    if (segment >= 100)
        return defaultCase;
    let cumulativePercentage = 0;
    for (const c of cases) {
        cumulativePercentage += c.percentage;
        if (segment < cumulativePercentage) {
            if (stickiness)
                storeSegment(c);
            if (!window['lazy_test_case'])
                window['lazy_test_case'] = c;
            return c.config;
        }
    }
}
function getStoredSegment(userId) {
    const storedData = localStorage.getItem(`lazy_segment`);
    if (!storedData)
        return null;
    return JSON.parse(storedData);
}
export function getExperimentKV() {
    if (!window['lazy_test_case'])
        return [];
    return [{ key: 'render', value: window['lazy_test_case'].renderMarginPercent }];
}
export function getExperiment() {
    return window['lazy_test_case'];
}
export function storeSegment(caseConf) {
    localStorage.setItem(`lazy_segment`, JSON.stringify({
        ...caseConf,
        timestamp: Date.now()
    }));
}
export function isSegmentValid(timestamp, stickinessTime) {
    if (!stickinessTime)
        return true;
    let passedTime = Date.now() - timestamp;
    console.log(`[SHATSU] TIMESTAMP ${passedTime} <= ${stickinessTime * 1000}`);
    if (passedTime <= (stickinessTime * 1000))
        return true;
    return false;
}
